const Contact = () => {
  const email = "ikejrmillsowoo@gmail.com";

  return (
    <div className="container py-5" style={{ maxWidth: "680px" }}>
      <h2 className="section-title mb-4">Contact Me</h2>

      <div className="contact-wrap">
        <p className="text-muted mb-4" style={{ fontSize: "0.95rem", lineHeight: 1.65 }}>
          I'd love to connect. Whether you have a project in mind, a role to fill, or just want to
          chat about tech and healthcare — feel free to reach out.
        </p>

        <form action={`mailto:${email}`} method="POST" encType="text/plain">
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input type="text" className="form-control" placeholder="Your Name" />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input type="email" className="form-control" placeholder="your@email.com" />
          </div>
          <div className="mb-4">
            <label className="form-label">Message</label>
            <textarea className="form-control" rows="5" placeholder="Your message..."></textarea>
          </div>
          <button type="submit" className="btn-primary-custom w-100">
            Send Message
          </button>
        </form>

        <div className="text-center mt-4 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
          <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
            Or email me directly at{" "}
            <a href={`mailto:${email}`} style={{ color: "var(--brand)", fontWeight: 600 }}>
              {email}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
